export default "__VITE_ASSET__DRSptIQS__"